// extracted by mini-css-extract-plugin
export default {"marginBottom":"ArticleListingCRPage_marginBottom__GnvcI","nonFeatured":"ArticleListingCRPage_nonFeatured__es3mt"};